import { defineComponent as _defineComponent } from 'vue'

import router from '@/router';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
router.replace(route.path.replace('/home', ''))


return (_ctx: any,_cache: any) => {
  return null
}
}

})